import { Col, Link, Row, Text } from '@opendoor/bricks-next';
import { IconStar, IconStarFilled, IconStarHalfFilled } from '@tabler/icons-react';
import type { EntryComponent } from 'cms/entries/entries';
import type { IFcTrustBanner } from 'declarations/contentful';

import { FCContentContainer, FCContentContainerWrapper } from './shared/FCLayout';

const ReviewStars = ({ rating }: { rating: number }) => {
  const rounded = Math.round(rating * 2) / 2;
  const fullStars = Math.floor(rounded);
  const hasHalf = rounded % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

  return (
    <Row gap="$2x" alignItems="center">
      {Array.from({ length: fullStars }, (_, i) => (
        <IconStarFilled key={`full-${i}`} size={24} color="#051a44" />
      ))}
      {hasHalf && <IconStarHalfFilled key="half" size={24} color="#051a44" />}
      {Array.from({ length: emptyStars }, (_, i) => (
        <IconStar key={`empty-${i}`} size={24} color="#051a44" />
      ))}
    </Row>
  );
};

const RenderFCTrustBanner = (entry: IFcTrustBanner) => {
  const { fields } = entry;

  return (
    <FCContentContainerWrapper alignItems="center" style={{ backgroundColor: '#ECE9E7' }}>
      <FCContentContainer alignItems="center" width="100%">
        <Col
          py="$12x"
          alignItems="center"
          gap="$12x"
          width="100%"
          $largerThanSM={{ display: 'none' }}
        >
          <Row gap="$6x" width="100%">
            <Col flexGrow={1} flexBasis={0}>
              <Text tag="p" typography="$labelSmall" textAlign="center">
                {fields.textSection1Headline}
              </Text>
              <Text tag="p" typography="$labelSmall" textAlign="center">
                {fields.textSection1Description}
              </Text>
            </Col>
            <Col flexGrow={1} flexBasis={0}>
              <Text tag="p" typography="$labelSmall" textAlign="center">
                {fields.textSection2Headline}
              </Text>
              <Text tag="p" typography="$labelSmall" textAlign="center">
                {fields.textSection2Description}
              </Text>
            </Col>
          </Row>
          <Col gap="$2x" alignItems="center">
            <ReviewStars rating={fields.reviewStars} />
            <Link
              href={fields.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              analyticsName="opendoor-reviews"
            >
              <Text tag="p" typography="$labelXsmall" textDecorationLine="underline">
                {fields.linkText}
              </Text>
            </Link>
          </Col>
        </Col>
        <Row
          alignItems="center"
          gap="$8x"
          py="$14x"
          display="none"
          $largerThanSM={{ display: 'flex' }}
        >
          <ReviewStars rating={fields.reviewStars} />

          <Text tag="p" typography="$labelXlarge" style={{ color: '#051a44' }}>
            {fields.textSection1Headline} {fields.textSection1Description} |{' '}
            {fields.textSection2Headline} {fields.textSection2Description} |{' '}
            <Link
              href={fields.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              analyticsName="opendoor-reviews"
            >
              <Text
                tag="span"
                display="inline"
                typography="$labelXlarge"
                textDecorationLine="underline"
              >
                {fields.linkText}
              </Text>
            </Link>
          </Text>
        </Row>
      </FCContentContainer>
    </FCContentContainerWrapper>
  );
};

const FCTrustBanner: EntryComponent<IFcTrustBanner> = {
  render: RenderFCTrustBanner,
};

export default FCTrustBanner;
